import React from 'react';

const ArrowRight = ({ size = 24, fill = '#008BD2' }) => {
  return (
    <svg
      width={`${size}px`}
      height={`${size}px`}
      viewBox='0 0 24 24'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <title>Icon - arrow</title>
      <g id='Icon---arrow' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
        <g id='#Container' transform='translate(7.000000, 5.876000)' fill={fill} fillRule='nonzero'>
          <polygon
            id=''
            transform='translate(5.000000, 6.000000) rotate(-90.000000) translate(-5.000000, -6.000000) '
            points='5 9.708 11 3.708 9.584 2.292 5 6.9 0.416 2.292 -1 3.708'
          ></polygon>
        </g>
      </g>
    </svg>
  );
};

export default ArrowRight;
